/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Texterror } from "../../../constants/Texterror";
import { getSession } from "../../../redux/actions/authActions";
import { editfacility } from "../../../redux/actions/dbactions/facilityActions";
import { verifyFacility } from "../../../constants/Validation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const VerifyFacility = ({
  show,
  dispatch,
  onHide,
  setRefresh,
  setVerifymodal,
}) => {
  const { currentData } = useSelector((state) => state.facilitylist);
  const { user_profile_id, role_id } = getSession();
  const { newUser } = useSelector((state) => state.facilitylist);

  const {
    svcf_name,
    svcf_id,
    svcf_verifier_full_name,
    svcf_verifier_phn_nbr,
    svcf_verifier_address,
    svcf_verifier_notes_txt,
  } = currentData;

  // const handleCancel = () => {
  //   history.goBack();
  // };

  const updateFacility = (values) => {
    values.sys_user_id = user_profile_id;
    values.role_id = role_id;
    dispatch(editfacility(values, svcf_id));
  };

  useEffect(() => {
    if (newUser?.usr?.rec) {
      setRefresh(true);
      setVerifymodal(false);
    }
  }, [newUser]);

  return (
    <Modal className="edit_modal profile " show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Verify Facility: ${svcf_name}`}</h5>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            svcf_verifier_full_name: svcf_verifier_full_name || "",
            svcf_verifier_phn_nbr: svcf_verifier_phn_nbr || "",
            svcf_verifier_address: svcf_verifier_address || "",
            svcf_verifier_notes_txt: svcf_verifier_notes_txt || "",
            sys_user_id: user_profile_id,
            user_profile_id: user_profile_id,
            role_id: role_id,
          }}
          validationSchema={verifyFacility}
          onSubmit={(values) => {
            updateFacility(values);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_verifier_full_name">
                      Verifiyer fullname
                    </label>
                    <Field
                      className={`form-control ${
                        touched.svcf_verifier_full_name &&
                        errors.svcf_verifier_full_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_verifier_full_name"
                      placeholder="Provider verifiyer full name"
                      type="input"
                    />
                    <ErrorMessage
                      name="svcf_verifier_full_name"
                      component={Texterror}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <label htmlFor="svcf_verifier_phn_nbr">Mobile Number</label>
                    <PhoneInput
                      country={"us"}
                      value={values.svcf_verifier_phn_nbr}
                      onChange={(phone) =>
                        setFieldValue("svcf_verifier_phn_nbr", phone)
                      }
                      inputProps={{
                        name: "svcf_verifier_phn_nbr",
                        required: true,
                        className: `form-control ${
                          touched.svcf_verifier_phn_nbr &&
                          errors.svcf_verifier_phn_nbr
                            ? "is-invalid"
                            : ""
                        }`,
                      }}
                    />
                    <ErrorMessage
                      name="svcf_verifier_phn_nbr"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mb-3">
                    <Field
                      className={`form-control ${
                        touched.svcf_verifier_address &&
                        errors.svcf_verifier_address
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_verifier_address"
                      placeholder="Full address"
                      type="input"
                    />
                  </div>
                  <div className="mb-3">
                    <Field
                      as={"textarea"}
                      rows={4}
                      className={`form-control ${
                        touched.svcf_verifier_notes_txt &&
                        errors.svcf_verifier_notes_txt
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svcf_verifier_notes_txt"
                      placeholder="How did you verify this facility?"
                      type="input"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="mini_edit flex justify-end gap-1">
                    <button
                      onClick={onHide}
                      className="py-2 px-[14px] text-[13px] font-semibold text-[#26262A] border border-[#E9E9E9] !rounded-md w-32 hover:opacity-80"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="py-2 px-[14px] text-[13px] font-semibold bg-[#1340CD] text-white !rounded-md w-32 hover:opacity-80"
                    >
                      Submit
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
